import React from "react";
import { ArrowDown } from "lucide-react";
import { ReactTyped } from "react-typed";
import heroBg from "../assets/Background.jpg";

export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-screen flex items-center justify-start overflow-hidden py-20">

      {/* Background Image */}
      <img
        src={heroBg}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Grey Overlay (same opacity feel) */}
      <div className="absolute inset-0 bg-gray-900/60"></div>

      {/* Content */}
      <div className="relative z-10 text-left px-6 max-w-8xl">

        {/* Main Title */}
        <h1 className="text-5xl md:text-8xl font-obra leading-[1.1] mb-6">
  <span className="text-white">
    Professional{" "}
  </span>
  <span className="bg-gradient-to-r from-[#FFD550] via-[#FFC350] to-[#FFB000] bg-clip-text text-transparent">
    Social Media Marketing Agency
  </span>
</h1>

        {/* Typing Tagline (UNCHANGED — only color updated) */}
        <h2 className="text-xl md:text-1.8xl font-medium text-white leading-relaxed">
  Professional Social Media Management for Medium & Small Businesses in Europe.{" "}
  <br />
  We keep your business{" "}
  <span className="bg-gradient-to-r from-[#FFD550] via-[#FFC420] to-[#FFB000] bg-clip-text text-transparent font-semibold">
    <ReactTyped
      strings={[
        "active and engaging",
        "trusted and credible",
        "visible and growing",
        "consistent and impactful"
      ]}
      typeSpeed={60}
      backSpeed={40}
      loop
    />
  </span>{" "}
  - without taking your time.
</h2>

        {/* CTA Button (unchanged except color theme) */}
        <div href="#work" className="mt-8">
  <button
  onClick={() => {
    document.getElementById("work")?.scrollIntoView({
      behavior: "smooth",
    });
  }}
  className="
    group relative overflow-hidden px-8 py-3 rounded-sm 
    font-obra tracking-wider text-sm text-white
    bg-gradient-to-r from-slate-900 to-blue-900
    border border-yellow-300/40
    transition-all duration-300 hover:scale-105
    shadow-[0_0_8px_rgba(255,255,150,0.4)]
    hover:shadow-[0_0_18px_rgba(255,255,180,0.9),0_0_30px_rgba(100,150,255,0.6)]
    animate-glow
  "
>
  <span className="relative z-10">View Our Work</span>

  {/* Shine */}
  <span className="
    absolute inset-0 
    bg-gradient-to-r from-transparent via-white/30 to-transparent 
    translate-x-[-100%] 
    group-hover:translate-x-[100%] 
    transition-transform duration-1000
  "></span>

  {/* Glow */}
  <span className="
    absolute inset-0 rounded-sm
    opacity-0 group-hover:opacity-100
    transition duration-300
    bg-[radial-gradient(rgba(255,255,200,0.25),transparent_70%)]
  "></span>
</button>
</div>

      </div>
    </section>
  );
}